module.exports = __webpack_public_path__ + "img/GainIntelligence.606e6300.png";